<div
  class="md:h-13 border-t dark:border-t-slate-600 py-3 md:pb-0 pt-4 mb-5 text-sm text-gray-600 px-4  md:w-[90%] mx-auto">
  <div class="  flex flex-col md:flex-row justify-between items-center gap-4">
    <!-- Left Side -->
    <div class="text-xs lg:text-sm">
      <p>{{"AllRightsReserved.©2025SuknaCapital" | translate}}</p>
    </div>
    <!-- Right Side -->
    <div class="text-xs lg:text-sm">
      @if(this.user$ | async; as user){
      <p>{{"designedAndDevelopedBySuknaCapital" | translate}}</p>
      }@else {
      <div class="flex items-center gap-2">
        <p>{{"CMALicense24284-02" | translate}}</p>
        <span class="h-4 w-px bg-green-500 dark:bg-gray-500"></span>
        <p>{{"CRNo.1010808216" | translate}}</p>
      </div>
      }
    </div>
  </div>
</div>